var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"contact"},[_c('div',[_c('a',{staticClass:"link",attrs:{"href":_vm.config.site_host,"target":"_blank"}},[_vm._v("网站首页")])])]),_vm._v(" "),_c('white-space'),_vm._v(" "),_c('white-space')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2790b4b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Footer.vue
// module id = null
// module chunks = 